import { useUserInfoStore } from '~/stores/useUserInfo'

export default defineNuxtPlugin(() => {
  /**
   * 初始化用户数据
   */
  const userStore = useUserInfoStore()
  userStore.getInitUserInfo()
})
